<div class="component-viewer">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Outing</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="container-fluid">
        <div class="row">
          <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </div>
        <div class="row">
          <div class="col-3">
            <div>Name</div>
          </div>
          <div class="col">
            <div>Created By</div>
          </div>
          <div class="col">
            <div>Created Date</div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <div>{{outingDetailsDto.details.name}}</div><br />
          </div>
          <div class="col">
            <div>{{outingDetailsDto.details.createdByUser}}</div><br />
          </div>
          <div class="col">
            <div>{{outingDetailsDto.details.createdDate | date: 'mediumDate'}}</div><br />
          </div>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button (click)="editOuting()">Edit</button>
    </mat-card-actions>
  </mat-card>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Iterations</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <table mat-table [dataSource]="iterationsDataSource">
        <ng-container matColumnDef="courseName">
          <th mat-header-cell *matHeaderCellDef>Course </th>
          <td mat-cell *matCellDef="let iteration"> {{iteration.courseName}} </td>
        </ng-container>
        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef>Start Date </th>
          <td mat-cell *matCellDef="let iteration"> {{iteration.startDate | date: 'mediumDate'}} </td>
        </ng-container>
        <ng-container matColumnDef="cost">
          <th mat-header-cell *matHeaderCellDef>Cost </th>
          <td mat-cell *matCellDef="let iteration"> ${{iteration.cost}} </td>
        </ng-container>
        <ng-container matColumnDef="fullAddress">
          <th mat-header-cell *matHeaderCellDef>Address </th>
          <td mat-cell *matCellDef="let iteration"> {{iteration.fullAddress}} </td>
        </ng-container>
        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef>Edit </th>
          <td mat-cell *matCellDef="let iteration"> 
            <button mat-icon-button color="primary" [routerLink]="['../../iteration/edit/', iteration.id]"> <mat-icon>edit</mat-icon> </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="iterationsDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: iterationsDisplayedColumns;"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-header>
      <mat-card-title>Permissions</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <table mat-table [dataSource]="permissionsDataSource">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name </th>
          <td mat-cell *matCellDef="let permission"> {{permission.name}} </td>
        </ng-container>
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef>First Name </th>
          <td mat-cell *matCellDef="let permission"> {{permission.firstName}} </td>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef>Last Name </th>
          <td mat-cell *matCellDef="let permission"> {{permission.lastName}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="permissionsDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: permissionsDisplayedColumns;"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>